import { Link, NavLink } from "react-router-dom"
import styled from "styled-components"
import { NumericFormat } from "react-number-format"
import "../assets/fonts/Sequel-Light.woff"
import "../assets/fonts/Sequel.ttf"

export const AppWrapper = styled.div`
  font-size: calc(0.8rem + 0.4vmax);
`
export const Heading1 = styled.h1`
  font-family: 'Sequel-Light', 'Poppins', sans-serif;
    color: #55585A;
  color: ${(props) => props.theme.white};
  font-size: ${(props) => props.theme.fontSizeXLarge};
  font-weight: ${(props) => props.theme.fontWeightBold};
` 


export const Heading2 = styled.h2`
    font-family: 'Sequel-Light', 'Poppins', sans-serif;
    color:  ${(props) => props.theme.darkGreen};
  font-size: ${(props) => props.theme.fontSizeLarge};
  font-weight: ${(props) => props.theme.fontWeightBold};
`

export const Heading3 = styled.h3`
    font-family: 'Sequel-Light', 'Poppins', sans-serif;
    color: #55585A;
  font-size: ${(props) => props.theme.fontSizeMedium};
  font-weight: ${(props) => props.theme.fontWeightBase};
  margin-bottom: 1em;
`

export const Heading4 = styled.h4`
    font-family: 'Sequel-Light', 'Poppins', sans-serif;
    color: #55585A;
  font-size: ${(props) => props.theme.fontSizeMediumSmall};
  font-weight: ${(props) => props.theme.fontWeightBase};
  margin-bottom: 1em;
`

export const Heading5 = styled.h5`
    font-family: 'Sequel-Light', 'Poppins', sans-serif;
    color: #55585A;
  font-size: ${(props) => props.theme.fontSizeMedium};
  font-weight: ${(props) => props.theme.fontWeightBold};
  margin-bottom: 1em;

  @media print {
    display: ${(props) => (props.type === "dont-print" ? "none" : "block")};
`

export const Heading6 = styled.h6`
    font-family: 'Sequel-Light', 'Poppins', sans-serif;
    color: #55585A;
  font-size: ${(props) => props.theme.fontSizeSmall};
  font-weight: ${(props) => props.theme.fontWeightBase};
  margin-bottom: 1em;
`

export const ParagraphText = styled.p`
  font-family: "Trebuchet MS", 'Poppins',  Helvetica, sans-serif;
  font-size: ${(props) => props.theme.fontSizeBase};
  &:not(:last-child) {
    margin-bottom: 0.3em;
  }
`

export const HeaderWrapper = styled.header`
  background-color: ${(props) => props.theme.brightGreen};
  margin-bottom:20px;

  & h1 {
    padding-left:30px;
    padding-top:50px;
    flex-grow:3;
  }

  @media print {
    margin:0;
    background:#fff;

    & h1 {
      color:#000;
    }
  }
`

export const HeaderContainer = styled.div`
    background-color: #b6cf3c;
    height: 220px;
    width: 100%;
    z-index: 1;
    position: relative;
    display:flex;
    justify-content: flex-start;
    align-items: top;



    &:before {
      PageWrapper
      content: '';
    width: 100%;
    position: absolute;
    bottom: -56px;
    height:  90px;
    background-color: #fff;
    transform: skew(0,2deg);
    left: 0;
    right: 0;
    }

    @media print {
      height:100px;
      background:#fff;

    }
`


export const DisclaimerWrapper = styled.div`
  flex-direction: column;
  width: 55%;
  padding: 1em;
`

export const IconImage = styled.img`
  width: 2em;
  height: 2em;
`

export const InfoBoxWrapper = styled.div`
  border: 1px solid ${(props) => props.theme.midBlue};
  background-color: ${(props) => props.theme.lightBlue};
  display: flex;
  padding: 1em;
  * {
    font-size: ${(props) => props.theme.fontSizeBase};
  }
  ${Heading3} + & {
    margin-top: 1em;
  }
    ${Heading5} + & {
    margin-top: 1em;
  }
`
export const InfoBoxContainer = styled.div`
  display: flex;
  flex-direction: column;
  &:last-child {
    margin-left: 1em;
  }

  & p {
    font-family: "Trebuchet MS", 'Poppins',  Helvetica, sans-serif;
    font-size: ${(props) => props.theme.fontSizeSmall};
  }
`
export const InfoBoxOrderedList = styled.ol`
  margin: 0;
  padding-left: 0.5em;
`

export const ListItem = styled.li`
  padding: 0.25em 0 0.25em 0;
  &:first-child {
    padding-top: 0;
  }
`

export const EmissionsDisplayWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  padding: 1em 3em;
  * {
    font-size: 1.25vmax;
  }
`
export const EmissionsDisplayItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 28%;
`

export const EmissionsDisplayForestItemContainer = styled(
  EmissionsDisplayItemContainer
)`
  width: 38%;
  ${ParagraphText}:not(:last-child) {
    padding-bottom: 1em;
  }
`

export const EmissionsDisplayForestItemImageWrapper = styled.div`
  display: flex;
  align-items: center;
`

export const EmissionsDisplayForestTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  padding-left: 1em;
`

export const EmissionsIconImage = styled.img`
  width: 10vmax;
  height: 10vmax;
  align-self: center;
  justify-content: center;
`

export const FormGroupWrapper = styled.div`
  background-color: ${(props) => props.theme.lightGreen};
  border: 1px solid ${(props) => props.theme.midGreen};
  padding: 1em;
  margin-top: 1.2em;
`
export const Fieldset = styled.fieldset`
  border: none;
  margin: 0;
  padding: 0;
`

export const Legend = styled.legend`
  font-family: "Trebuchet MS", 'Poppins',  Helvetica, sans-serif;
  margin-bottom: 1em;
  padding: 0;

  & p {
  font-family: "Trebuchet MS", 'Poppins',  Helvetica, sans-serif;
    line-height:1.3em;
  }
`

export const Label = styled.label`
  margin-bottom: 0.2em;
`

export const HelpText = styled.span`
  font-size: ${(props) => props.theme.fontSizeXSmall};
  margin: 0.4em 0 0.2em 0;
`

export const ValidationText = styled.span`
  font-size: ${(props) => props.theme.fontSizeXSmall};
  margin: 0.4em 0 0.2em 0;
  color: ${(props) => props.theme.red} !important;
`


export const RadioWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

export const RadioItemWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  &:not(:last-child) {
    margin-bottom: 0.2em;
  }
  ${Label} {
    display: flex;
    align-items: center;
    margin-top: 0;
  }
`
export const Span = styled.span``

export const RadioInput = styled.input.attrs(() => ({
  type: "radio",
}))`
  appearance: none;
  background-color: #fff;
  margin: 0;
  font: inherit;
  color: ${(props) => props.theme.darkGrey};
  width: 1.15em;
  height: 1.15em;
  border: 1px solid ${(props) => props.theme.darkGrey};
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  + ${Span} {
    margin-left: 0.5em;
    width: calc(100% - 1.65em);
  }
  &:focus {
    border-color: ${(props) => props.theme.darkBlue};
  }
  &:before {
    content: "";
    width: 70%;
    height: 70%;
    border-radius: 50%;
    display: block;
  }
  &:checked::before {
    background-color: ${(props) => props.theme.darkGreen};
  }
  &[aria-invalid="true"] {
    border-color: ${(props) => props.theme.red};
    border-width: 1.5px;
  }
`
export const RadioContentWrapper = styled.div`
  padding-left: 1.7em;
`
export const FormInputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 16em;
  width: 100%;
  &:not(:last-child) {
    margin-bottom: 1em;
  }

   @media screen and (min-width: 600px) {
    max-width: 25em;

  }
`

export const FormInputContainer = styled.div`
  display: flex;
  margin-top: 0.2em;
  max-width:14em;
 width:100%;
`

export const UnitWrapper = styled.div`
  background-color: ${(props) => props.theme.lightGrey};
  height: ${(props) => props.theme.inputHeight};
  font-size: ${(props) => props.theme.fontSizeSmall};
  border: 1px solid ${(props) => props.theme.darkGrey};
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0.3em;
  margin-left: -1px;
`

export const UnitText = styled.p`
  line-height: 1;
`
export const NumericFormatInput = styled(NumericFormat)`
  padding: 0.3em;
  height: ${(props) => props.theme.inputHeight};
  width: 100%;
    max-width: 14em;

  font-size: ${(props) => props.theme.fontSizeSmall};
  border: 1px solid ${(props) => props.theme.darkGrey};
  &: {
    outline: none;
    box-shadow: 0 0 0 1px inset ${(props) => props.theme.darkGrey};
  }
  &[aria-invalid="true"] {
    border-color: ${(props) => props.theme.red};
    box-shadow: 0 0 0 1px inset ${(props) => props.theme.red};
  }
`

export const Input = styled.input`
  padding: 0.3em;
  height: ${(props) => props.theme.inputHeight};
  width: 100%;
  max-width: 14em;
  font-size: ${(props) => props.theme.fontSizeSmall};
  border: 1px solid ${(props) => props.theme.darkGrey};
  &:focus {
    outline: none;
    box-shadow: 0 0 0 1px inset ${(props) => props.theme.darkGrey};
  }
  &[aria-invalid="true"] {
    border-color: ${(props) => props.theme.red};
    box-shadow: 0 0 0 1px inset ${(props) => props.theme.red};
  }
`
export const TextArea = styled.textarea `
  padding: 0.3em;
  height: ${(props) => props.inputHeight};
  width: 100%;
  font-size: ${(props) => props.theme.fontSizeSmall};
  border: 1px solid ${(props) => props.theme.darkGrey};
  &:focus {
    outline: none;
    box-shadow: 0 0 0 1px inset ${(props) => props.theme.darkGrey};
  }
  &[aria-invalid="true"] {
    border-color: ${(props) => props.theme.red};
    box-shadow: 0 0 0 1px inset ${(props) => props.theme.red};
  }
`

export const Select = styled.select`
  width: 100%;
  font-size: ${(props) => props.theme.fontSizeSmall};
  appearance: none;
  height: ${(props) => props.theme.inputHeight};
  background-image: url("${require("./icons/down-icon.svg").default}");
  background-size: 1em;
  background-repeat: no-repeat;
  background-position-x: calc(100% - 0.5em);
  background-position-y: 0.5em;
  padding: 0.3em;
  &:focus {
    outline: none;
    box-shadow: 0 0 0 1px inset ${(props) => props.theme.darkGrey};
  }
  &[aria-invalid="true"] {
    border-color: ${(props) => props.theme.red};
    box-shadow: 0 0 0 1px inset ${(props) => props.theme.red};
  }
`

export const PrimaryButtonLink = styled(Link)`
  font-family: "Sequel", "Trebuchet MS", 'Poppins',  Helvetica, sans-serif;
  background-color: ${(props) => props.theme.darkGreen};
  border: 1px solid ${(props) => props.theme.darkGreen};
  color: ${(props) => props.theme.white};
  text-transform: uppercase;
  text-decoration: none;
  padding: 0.3em 1.5em;
  transition: 0.2s ease-in-out background-color;
  &:hover,
  &:focus,
  &:focus-visible {
    outline: none;
    background-color: ${(props) => props.theme.white};
    color: ${(props) => props.theme.darkBlue};
  }
  &[disabled] {
    opacity: 0.7;
    pointer-events: none;
  }

`

export const PrimaryButton = styled.button`
  font-family: "Sequel", "Trebuchet MS", 'Poppins',  Helvetica, sans-serif;

  background-color: ${(props) => props.theme.darkGreen};
  border: 1px solid ${(props) => props.theme.darkGreen};
  color: ${(props) => props.theme.white};
  text-decoration: none;
  padding: 0.3em 1.5em;
    text-transform: uppercase;

  font-size: ${(props) => props.theme.fontSizeBase};
  transition: 0.2s ease-in-out background-color;
  &:hover,
  &:focus,
  &:focus-visible {
    outline: none;
    background-color: ${(props) => props.theme.white};
    color: ${(props) => props.theme.darkBlue};
  }
  &[disabled] {
    opacity: 0.7;
    pointer-events: none;
  }

  & + a {
    margin-left: 1em;
  }

  
  @media print {
    display:none;
  }
`

export const SecondaryButton = styled.button`
  font-family: "Sequel", "Trebuchet MS", 'Poppins',  Helvetica, sans-serif;

  background-color: ${(props) => props.theme.white};
  border: 1px solid ${(props) => props.theme.darkBlue};
  color: ${(props) => props.theme.darkBlue};
  text-decoration: none;
  padding: 0.3em 1.5em;
    text-transform: uppercase;

  font-size: ${(props) => props.theme.fontSizeBase};
  transition: 0.2s ease-in-out background-color;
  &:hover,
  &:focus,
  &:focus-visible {
    outline: none;
    background-color: ${(props) => props.theme.white};
    color: ${(props) => props.theme.darkBlue};
  }
  &[disabled] {
    opacity: 0.7;
    pointer-events: none;
  }

  & + a {
    margin-left: 1em;
  }

  
  @media print {
    display:none;
  }
`

export const SecondaryButtonLink = styled(Link)`
  font-family: "Sequel", "Trebuchet MS", 'Poppins',  Helvetica, sans-serif;

  background-color: ${(props) => props.theme.brightGreen};
  border: 1px solid ${(props) => props.theme.brightGreen};
  color: ${(props) => props.theme.darkGreen};
  text-transform: uppercase;
  text-decoration: none;
  padding: 0.3em 1.5em;
  transition: 0.2s ease-in-out background-color;
  &:hover,
  &:focus,
  &:focus-visible {
    outline: none;
    background-color: ${(props) => props.theme.darkBlue};
    color: ${(props) => props.theme.white};
  }
`

export const TableHead = styled.thead`
& > tr {
      background-color: ${(props) => {
        if(props.highlightHeader) {
          return props.theme.brightGreen;
        }
    }};

}
`

export const FormTableHeaderCell = styled.th`
  font-family: "Trebuchet MS", 'Poppins',  Helvetica, sans-serif;

  font-weight: ${(props) => props.theme.fontWeightBase};
  vertical-align: middle;
  text-align: left;
  padding-right: 1.5em;
  padding-bottom: 1.5em;
`

export const FormTableCell = styled.td`
  font-family: "Trebuchet MS", 'Poppins',  Helvetica, sans-serif;

  padding-bottom: 1.5em;
  &:not(:last-child) {
    padding-right: 1.5em;
  }

  ${FormInputContainer} {
    margin-top: 0;
  }

  ${FormInputWrapper} {
    width: auto;
  }
`

export const FormTableRow = styled.tr``

export const FormTableWrapper = styled.table``

export const TableBody = styled.tbody`
${(props) => {
  return props.type === "summary-table" ? (`
  width: 100%;

  ${DisplayTableCell} {
    font-size: ${props.theme.fontSizeSmall};
  }

  ${DisplayTableRow}:nth-child(2n) {
    ${DisplayTableCell} {
      background-color: ${(props) =>  props.type === "draft" ? "#fff8dc" :props.theme.lightGrey};

    }
  }

 
  `) : (``);
}}

`

export const DisplayTableHeaderCell = styled.th`
  font-family: "Trebuchet MS", 'Poppins',  Helvetica, sans-serif;

  font-weight: ${(props) => props.theme.fontWeightBase};
  vertical-align: middle;
  text-align: right;
  padding: 0.5em 1em 0.5em 0;
  width: 20%;

  border-left: ${(props) => props.type === "borderLeft" ? `1px solid ${props.theme.darkGrey}` : "none"};
  
  @media print {
    padding:0 0.5em;
    font-size: ${(props) => props.theme.fontSizeSmall};
  }
`

export const DisplayTableCell = styled.td`
  font-family: "Trebuchet MS", 'Poppins',  Helvetica, sans-serif;
  padding: 0.5em 1em 0.5em 0.2em;

  border: 1px solid ${(props) => props.theme.darkGrey};
  vertical-align: middle;


    width: ${(props) => props.subStyle === "analysis-table" ? "40%": "auto"};

    @media print {
      padding:0.1em !important;
      font-size: ${(props) => props.theme.fontSizeSmall};
    }
  
`

export const DisplayTableWrapper = styled.table`
  border-collapse: collapse;
  margin-bottom: 3em;
  width: 100%;

  ${DisplayTableHeaderCell} {
    width: ${(props) => props.type === "summary" ? "10%" : "20%"};
  }

  ${DisplayTableCell} {
    padding: 1em;
  }

`


export const DisplayTableRow = styled.tr`

  background: ${(props) => props.type === "draft" ? "#fff8dc" : "none"};

  &:nth-child(2n) {
    ${DisplayTableCell} {
      background-color: ${(props) =>  props.type === "draft" ? "#fff8dc" :props.theme.lightGrey};
    }
  }
`



export const DisplayTableHead = styled.thead`
  ${DisplayTableHeaderCell}:not(:first-child) {
    text-align: left;
  }

  ${(props) => {
    return props.type === "summary-table" ? (`

    ${DisplayTableHeaderCell} {
      text-align: center !important;
    }
    

    font-weight: ${props.theme.fontWeightBold};
    font-size: ${props.theme.fontSizeSmall};
    background-color: ${props.theme.lightGrey};
    border: 1px solid ${props.theme.darkGrey};
   
    `) : (``);
  }}

  ${DisplayTableHeaderCell} {
  
  }
`
export const DisplayTableFooter = styled.tfoot``

export const DisplayTableFooterRow = styled.tr`
  ${DisplayTableHeaderCell} {
    font-weight: ${(props) => props.theme.fontWeightBold};
  }
  &:empty {
    height: 2em;
  }
`

export const DisplayTableFooterCell = styled(DisplayTableCell)`
  font-family: "Trebuchet MS", 'Poppins',  Helvetica, sans-serif;

  background-color: ${(props) => props.theme.blueGrey};
  ${DisplayTableFooterRow}:first-child & {
    border-top-style: double;
    border-top-width: 3px;
  }
 `

 export const WhatIfTableHeaderCell = styled.th`
   font-family: "Trebuchet MS", 'Poppins',  Helvetica, sans-serif;

  font-weight: ${(props) => props.theme.fontWeightBase};
  vertical-align: middle;
  text-align: center;
  padding: 0.5em 1em;
  &:nth-child(1) {
    width:35%;
  }
  &:nth-child(1) {
  text-align: left;
  }
`

export const WhatIfTableRow = styled.tr`

  &:nth-child(2n) {
    background:#f3f3f3;
  }`

export const WhatIfTableCell = styled.td`
  font-family: "Trebuchet MS", 'Poppins',  Helvetica, sans-serif;

  border: none;
  vertical-align: middle;
  border-collapse: collapse;
  color: ${(props) => props.color};
  text-align: ${(props) => props.alignment};

  & div {
    max-width:14em;
  }
`

export const WhatIfTableFooter = styled.tfoot``

export const WhatIfTableFooterRow = styled.tr`
  ${WhatIfTableHeaderCell} {
    font-weight: ${(props) => props.theme.fontWeightBold};
  }
  &:empty {
    height: 2em;
  }
`

export const WhatIfTableFooterCell = styled(WhatIfTableCell)`
  ${WhatIfTableFooterRow}:first-child & {
    border-top-width: 3px;
  }
    font-family: "Trebuchet MS", 'Poppins',  Helvetica, sans-serif;

  font-weight:bold;
  text-align: center;
 `

export const GraphWrapper = styled.div`
  padding-left: 1em;
  padding-bottom: 6em;
  svg {
    overflow: visible;
  }
  @media screen and (min-width: 800px) {
    padding-left: 14%;
  }
`
export const GraphContainer = styled.div`
  position: relative;
`

export const GraphDisclaimerContainer = styled.div`
  position: absolute;
  top: 17%;
  z-index: 1;
  background-color: ${(props) => props.theme.white};
  width: 30%;
  left: 9%;
  padding: 0.3em;
`

export const GraphDisclaimerText = styled.p`
  font-size: calc(${(props) => props.theme.fontSizeSmall} - 0.3vmin);
  color: ${(props) => props.theme.red};
  font-weight: ${(props) => props.theme.fontWeightBold};
`
export const NavBarWrapper = styled.nav`
  display: flex;
  justify-content: stretch;
  width: 100%;
  flex-wrap: wrap;

  @media print {
    display:none;
  }


`

export const NavBarLink = styled(NavLink)`
  font-size: ${(props) => props.theme.fontSizeXSmall};
  text-decoration: none;
  background-color: ${(props) => props.theme.lightGrey};
  border: 1px solid ${(props) => props.theme.darkGreen};
  padding: 0.3em 0.5em;
  width: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-grow: 1;
  &.active {
    background-color: #9cc538;
    ${Span} {
      color: ${(props) => props.theme.white};
    }
  }
  &[disabled] {
    opacity: 0.8;
    pointer-events: none;
  }
`
export const PageWrapper = styled.div`
position:relative;
  z-index:200;
  max-width:1600px;
  margin:0 auto;
  font-size: calc(0.6rem + 0.4vmax); 
  margin-bottom: ${(props) => props.type === "disclaimer" ? "2em" : "0"};

`
export const PageSection = styled.div`
  margin-top: 2em;
  @media screen and (min-width: 600px) {
    max-width: ${(props) => (props.isFullWidth || props.type === "disclaimer" ? "100%" : "75%")};
  }


`

export const PageContainer = styled.div`
  margin: 2em 1.2em;

  @media print {
    display: ${(props) => (props.type === "dont-print" ? "none" : "block")};
  }
`

export const ButtonWrapper = styled.div`
  padding-top: 1.2em;
  display: flex;
  justify-content: ${(props) => props.alignButtons || "flex-start"};
  a:not(:last-child) {
    margin-right: 2em;
  }

  gap: ${(props) => props.type === "share-bar" ? "1em" : "0em"};
`

export const ModalHeader = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  ${Heading2} {
    width: 100%;
    text-align: center;
    font-size: ${(props) => props.theme.fontSizeXLarge};
  }
`
export const ModalCloseButton = styled.button`
  width: 2em;
  height: 2em;
  padding: 0.2em;
  border: none;
  background-color: transparent;
  border: 1.5px solid transparent;
  ${IconImage} {
    width: 100%;
    height: 100%;
  }
  &:focus {
    border-color: ${(props) => props.theme.darkGrey};
  }
`
export const ModalBody = styled.div`
  padding: 1em 0;
  display: flex;
  justify-content: center;
`
export const LoaderWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 1em 2em;
`

export const LoaderContainer = styled.div`
  background-color: ${(props) => props.theme.brightGreen};
  border-radius: 50%;
  width: 6em;
  height: 6em;
  ${IconImage} {
    width: 100%;
    height: 100%;
    animation: spinning 1500ms infinite linear;
  }
`
export const ModalBodyWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 0.5em;
  ${PrimaryButtonLink}, ${PrimaryButton}, ${SecondaryButton} {
    margin-top: 1em;
    align-self: flex-end;
  }
`

export const UnorderedList = styled.ul``
export const InlineLink = styled.a`
  color: ${(props) => props.theme.lightGreen};
`
export const PageHeadingWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const ErrorText = styled(ParagraphText)`
  color: ${(props) => props.theme.red};
  font-weight: ${(props) => props.theme.fontWeightBold};
`

export const SuccessText = styled(ParagraphText)`
  color: ${(props) => props.theme.brightGreen};
  font-weight: ${(props) => props.theme.fontWeightBold};
`

export const PieGraphList = styled.ul`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0;
  width: 60vw;
`

export const PieGraphListItem = styled.li`
  display: flex;
  align-items: center;
  padding: 0.5rem;
`
export const PieGraphListDot = styled.div`
  width: 15px;
  height: 15px;
  margin-right: 15px;
  padding-right: 15px;
  background-color: ${(props) => props.color};
  border-radius: 50%;
`
export const PieGraphContainer = styled.div`
  display: flex;
`

export const FooterWrapper = styled.footer`
margin-top:90px;
width:100%;
min-height:100px;
background:#000;

@media print {
  display: none;
}

`;

export const FooterContainer = styled.div`
padding:40px 70px;

&  p {

font-size: ${(props) => props.theme.fontSizeXSmall};
font-style: italic;
color: #8b8b8b;
width:100%;
display:block;
border-top: 1px solid #fff;
padding-top:20px;
  }

  & a {
    color:#7e7e7e;
  }
`

export const SaveWrapper = styled.div`
margin-top:90px;
width:100%;
min-height:100px;
background:#000;
`

export const SaveContainer = styled.div`
padding:40px 70px 40px 70px;
width:100%;
display:flex;
flex-direction: column;

& > p:first-child {
  border-top: 1px solid #fff;
}

`

export const SaveText = styled.p`
font-size: ${(props) => props.theme.fontSizeXSmall};
font-style: italic;
color: #8b8b8b;
width:100%;
display:block;
padding-top:20px;

& a {
  color:#fff;
}
`


export const LogoWrapper = styled.div`
max-width:130px;
flex-shrink:1;
`

export const LogoImage = styled.img`
max-width:130px;
`;


export const PrivacyLink = styled.button`
margin-top:20px;`

export const LoginWrapper = styled.div`
  font-size: calc(0.8rem + 0.4vmax);
  width: 100%;
  height: 100vh;
  background-color: white;
  display: flex;
  flex-direction: column;

`
export const LoginSignInWrapper = styled.div`
  margin-top:60px;

  @media print {
    margin-top:0;
  }
`

export const PersonalDetailsWrapper = styled.div`
display: flex;
flex-direction: row;
width: 100%;
justify-content: space-between;
align-items: center;
margin-bottom:1em;
`
export const InlineButton = styled.button`
  background-color: transparent;
  border: none;
  color: ${(props) => props.theme.darkGreen};
  text-decoration: underline;
  cursor: pointer;
  padding: 0;
  font-size: ${(props) => props.theme.fontSizeBase};
  margin-right:0.5em;
  
  &:focus {
    outline: none;
  }
  :last-child {
  margin-right: 0em;
  }
`

export const PageBreak = styled.div`
@media print {
  page-break-after: always;
}
`;

export const ActionButtonBarWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`